import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=4af5db8c&scoped=true"
import script from "./NoData.vue?vue&type=script&lang=ts"
export * from "./NoData.vue?vue&type=script&lang=ts"
import style0 from "./NoData.vue?vue&type=style&index=0&id=4af5db8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af5db8c",
  null
  
)

export default component.exports